var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function getDynamicFormsData(lsKey) {
    if (lsKey === void 0) { lsKey = "steps"; }
    var raw = localStorage.getItem(lsKey);
    if (!raw)
        return null;
    var data;
    try {
        data = JSON.parse(raw);
    }
    catch (_a) {
        return null;
    }
    if (!Array.isArray(data))
        return null; // esperamos un array
    var detailsList = data
        .filter(function (item) {
        return item &&
            typeof item === "object" &&
            (item.pathUrl === "" ||
                item.pathUrl === "/initialInfo" ||
                item.pathUrl === "/add-business") &&
            item.details &&
            typeof item.details === "object";
    })
        .map(function (item) { return item.details; });
    if (detailsList.length === 0)
        return null;
    return Object.assign.apply(Object, __spreadArray([{}], detailsList, false));
}
